/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ApiBulkUploadValidationResult,
    ApiResult,
    ChargerMeterValue,
    DeviceActiveTransactionsResponse,
    DeviceConnectorTransactionsResponse,
    RfidBulkUploadRequest,
    RfidTagDto,
    Transaction,
    TransactionMeterValuesResponse,
} from "../models/index";
import {
    ApiBulkUploadValidationResultFromJSON,
    ApiBulkUploadValidationResultToJSON,
    ApiResultFromJSON,
    ApiResultToJSON,
    ChargerMeterValueFromJSON,
    ChargerMeterValueToJSON,
    DeviceActiveTransactionsResponseFromJSON,
    DeviceActiveTransactionsResponseToJSON,
    DeviceConnectorTransactionsResponseFromJSON,
    DeviceConnectorTransactionsResponseToJSON,
    RfidBulkUploadRequestFromJSON,
    RfidBulkUploadRequestToJSON,
    RfidTagDtoFromJSON,
    RfidTagDtoToJSON,
    TransactionFromJSON,
    TransactionToJSON,
    TransactionMeterValuesResponseFromJSON,
    TransactionMeterValuesResponseToJSON,
} from "../models/index";

export interface ChargerMeterValuesRequest {
    transactionId: number;
    limit?: number;
    cursor?: string;
    oldestFirst?: boolean;
}

export interface ChargerMeterValuesODataRequest {
    transactionId: number;
}

export interface DeleteRfidTagRequest {
    rfidTagId: number;
}

export interface DeviceActiveTransactionsRequest {
    deviceIdentity: string;
    connectorIndex?: number;
}

export interface InsertUpdateRfidTagRequest {
    body?: RfidTagDto;
}

export interface RfidBulkUploadCsvRequest {
    validateOnly?: boolean;
    body?: string;
}

export interface RfidBulkUploadJsonRequest {
    body?: RfidBulkUploadRequest;
}

export interface SetRfidTagDeviceGroupsRequest {
    rfidTagId: number;
    deviceGroupTags?: Array<string>;
}

export interface TransactionSearchRequest {
    limit?: number;
    cursor?: string;
    transactionId?: number;
    transactionLocalId?: string;
    centralSystemTransactionId?: string;
    idTag?: string;
}

export interface TransactionsRequest {
    deviceIdentity: string;
    connectorIndex: number;
    limit?: number;
    cursor?: string;
}

export interface TransactionsByDeviceODataRequest {
    deviceIdentity: string;
}

/**
 *
 */
export class ChargeTransactionsHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Charger Meter Values for single Charge Transaction. Voltage, Current (and more depending on the type of charger) readings sent by a charger during a single charge transaction
     */
    async chargerMeterValuesRaw(
        requestParameters: ChargerMeterValuesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<TransactionMeterValuesResponse>> {
        if (requestParameters["transactionId"] == null) {
            throw new runtime.RequiredError(
                "transactionId",
                'Required parameter "transactionId" was null or undefined when calling chargerMeterValues().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["limit"] != null) {
            queryParameters["limit"] = requestParameters["limit"];
        }

        if (requestParameters["cursor"] != null) {
            queryParameters["cursor"] = requestParameters["cursor"];
        }

        if (requestParameters["oldestFirst"] != null) {
            queryParameters["oldestFirst"] = requestParameters["oldestFirst"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/transactions/{transactionId}/charger-meter-values`.replace(
                    `{${"transactionId"}}`,
                    encodeURIComponent(
                        String(requestParameters["transactionId"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            TransactionMeterValuesResponseFromJSON(jsonValue),
        );
    }

    /**
     * Charger Meter Values for single Charge Transaction. Voltage, Current (and more depending on the type of charger) readings sent by a charger during a single charge transaction
     */
    async chargerMeterValues(
        requestParameters: ChargerMeterValuesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<TransactionMeterValuesResponse> {
        const response = await this.chargerMeterValuesRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Charger Meter Values OData by TransactionId. Probably unneccessary, given ChargerMeterValues can be included in TransactionsByDeviceOData or TransactionsOData using `$expand=ChargerMeterValues`
     */
    async chargerMeterValuesODataRaw(
        requestParameters: ChargerMeterValuesODataRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<ChargerMeterValue>>> {
        if (requestParameters["transactionId"] == null) {
            throw new runtime.RequiredError(
                "transactionId",
                'Required parameter "transactionId" was null or undefined when calling chargerMeterValuesOData().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/transactions/{transactionId}/charger-meter-values-odata`.replace(
                    `{${"transactionId"}}`,
                    encodeURIComponent(
                        String(requestParameters["transactionId"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(ChargerMeterValueFromJSON),
        );
    }

    /**
     * Charger Meter Values OData by TransactionId. Probably unneccessary, given ChargerMeterValues can be included in TransactionsByDeviceOData or TransactionsOData using `$expand=ChargerMeterValues`
     */
    async chargerMeterValuesOData(
        requestParameters: ChargerMeterValuesODataRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<ChargerMeterValue>> {
        const response = await this.chargerMeterValuesODataRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Delete RFID tag. Primary key not the string id.
     */
    async deleteRfidTagRaw(
        requestParameters: DeleteRfidTagRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["rfidTagId"] == null) {
            throw new runtime.RequiredError(
                "rfidTagId",
                'Required parameter "rfidTagId" was null or undefined when calling deleteRfidTag().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/rfidtags/{rfidTagId}`.replace(
                    `{${"rfidTagId"}}`,
                    encodeURIComponent(String(requestParameters["rfidTagId"])),
                ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Delete RFID tag. Primary key not the string id.
     */
    async deleteRfidTag(
        requestParameters: DeleteRfidTagRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deleteRfidTagRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get a device\'s active transactions
     */
    async deviceActiveTransactionsRaw(
        requestParameters: DeviceActiveTransactionsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceActiveTransactionsResponse>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceActiveTransactions().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["connectorIndex"] != null) {
            queryParameters["connectorIndex"] =
                requestParameters["connectorIndex"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/active-transactions`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceActiveTransactionsResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get a device\'s active transactions
     */
    async deviceActiveTransactions(
        requestParameters: DeviceActiveTransactionsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceActiveTransactionsResponse> {
        const response = await this.deviceActiveTransactionsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Insert or update a RFID tag. requires Permission.rfid_tags_manage or Permission.system_rfid_tags_manage.
     */
    async insertUpdateRfidTagRaw(
        requestParameters: InsertUpdateRfidTagRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/rfidtags`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: RfidTagDtoToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Insert or update a RFID tag. requires Permission.rfid_tags_manage or Permission.system_rfid_tags_manage.
     */
    async insertUpdateRfidTag(
        requestParameters: InsertUpdateRfidTagRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.insertUpdateRfidTagRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Bulk csv upload of RFID tag data (insert and/or update). requires Permission.rfid_tags_manage or Permission.system_rfid_tags_manage.
     */
    async rfidBulkUploadCsvRaw(
        requestParameters: RfidBulkUploadCsvRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiBulkUploadValidationResult>> {
        const queryParameters: any = {};

        if (requestParameters["validateOnly"] != null) {
            queryParameters["validateOnly"] = requestParameters["validateOnly"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "text/csv";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/rfidtags/bulk-upload/csv`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters["body"] as any,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiBulkUploadValidationResultFromJSON(jsonValue),
        );
    }

    /**
     * Bulk csv upload of RFID tag data (insert and/or update). requires Permission.rfid_tags_manage or Permission.system_rfid_tags_manage.
     */
    async rfidBulkUploadCsv(
        requestParameters: RfidBulkUploadCsvRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiBulkUploadValidationResult> {
        const response = await this.rfidBulkUploadCsvRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Bulk json upload of RFID tag data (insert and/or update). requires Permission.rfid_tags_manage or Permission.system_rfid_tags_manage. Response validationResults Column value is always zero, use FieldName to match the RfidUploadEntity field instead. Use FieldName=null for the row result.
     */
    async rfidBulkUploadJsonRaw(
        requestParameters: RfidBulkUploadJsonRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiBulkUploadValidationResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/rfidtags/bulk-upload/json`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: RfidBulkUploadRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiBulkUploadValidationResultFromJSON(jsonValue),
        );
    }

    /**
     * Bulk json upload of RFID tag data (insert and/or update). requires Permission.rfid_tags_manage or Permission.system_rfid_tags_manage. Response validationResults Column value is always zero, use FieldName to match the RfidUploadEntity field instead. Use FieldName=null for the row result.
     */
    async rfidBulkUploadJson(
        requestParameters: RfidBulkUploadJsonRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiBulkUploadValidationResult> {
        const response = await this.rfidBulkUploadJsonRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * All RFID tags OData
     */
    async rfidTagsOdataRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<RfidTagDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/rfidtags-odata`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(RfidTagDtoFromJSON),
        );
    }

    /**
     * All RFID tags OData
     */
    async rfidTagsOdata(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<RfidTagDto>> {
        const response = await this.rfidTagsOdataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Set an rfid tag\'s device groups. requires Permission.rfid_tags_manage or Permission.system_rfid_tags_manage. See also: DeviceGroupMapRfidTags
     */
    async setRfidTagDeviceGroupsRaw(
        requestParameters: SetRfidTagDeviceGroupsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["rfidTagId"] == null) {
            throw new runtime.RequiredError(
                "rfidTagId",
                'Required parameter "rfidTagId" was null or undefined when calling setRfidTagDeviceGroups().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["deviceGroupTags"] != null) {
            queryParameters["deviceGroupTags"] = requestParameters[
                "deviceGroupTags"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/rfidtags/{rfidTagId}/device-groups`.replace(
                    `{${"rfidTagId"}}`,
                    encodeURIComponent(String(requestParameters["rfidTagId"])),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Set an rfid tag\'s device groups. requires Permission.rfid_tags_manage or Permission.system_rfid_tags_manage. See also: DeviceGroupMapRfidTags
     */
    async setRfidTagDeviceGroups(
        requestParameters: SetRfidTagDeviceGroupsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.setRfidTagDeviceGroupsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Transaction search by transactionId, transactionLocalId and/or centralSystemTransactionId; or by idTag. Search by id should never return more than 3 results, therefore the limit/cursor params are only relevant for search by idTag.
     */
    async transactionSearchRaw(
        requestParameters: TransactionSearchRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceConnectorTransactionsResponse>> {
        const queryParameters: any = {};

        if (requestParameters["limit"] != null) {
            queryParameters["limit"] = requestParameters["limit"];
        }

        if (requestParameters["cursor"] != null) {
            queryParameters["cursor"] = requestParameters["cursor"];
        }

        if (requestParameters["transactionId"] != null) {
            queryParameters["transactionId"] =
                requestParameters["transactionId"];
        }

        if (requestParameters["transactionLocalId"] != null) {
            queryParameters["transactionLocalId"] =
                requestParameters["transactionLocalId"];
        }

        if (requestParameters["centralSystemTransactionId"] != null) {
            queryParameters["centralSystemTransactionId"] =
                requestParameters["centralSystemTransactionId"];
        }

        if (requestParameters["idTag"] != null) {
            queryParameters["idTag"] = requestParameters["idTag"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/transactions/transaction-search`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceConnectorTransactionsResponseFromJSON(jsonValue),
        );
    }

    /**
     * Transaction search by transactionId, transactionLocalId and/or centralSystemTransactionId; or by idTag. Search by id should never return more than 3 results, therefore the limit/cursor params are only relevant for search by idTag.
     */
    async transactionSearch(
        requestParameters: TransactionSearchRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceConnectorTransactionsResponse> {
        const response = await this.transactionSearchRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Device Connector Transactions
     */
    async transactionsRaw(
        requestParameters: TransactionsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceConnectorTransactionsResponse>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling transactions().',
            );
        }

        if (requestParameters["connectorIndex"] == null) {
            throw new runtime.RequiredError(
                "connectorIndex",
                'Required parameter "connectorIndex" was null or undefined when calling transactions().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["limit"] != null) {
            queryParameters["limit"] = requestParameters["limit"];
        }

        if (requestParameters["cursor"] != null) {
            queryParameters["cursor"] = requestParameters["cursor"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/connectors/{connectorIndex}/transactions`
                    .replace(
                        `{${"deviceIdentity"}}`,
                        encodeURIComponent(
                            String(requestParameters["deviceIdentity"]),
                        ),
                    )
                    .replace(
                        `{${"connectorIndex"}}`,
                        encodeURIComponent(
                            String(requestParameters["connectorIndex"]),
                        ),
                    ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceConnectorTransactionsResponseFromJSON(jsonValue),
        );
    }

    /**
     * Device Connector Transactions
     */
    async transactions(
        requestParameters: TransactionsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceConnectorTransactionsResponse> {
        const response = await this.transactionsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Device Transactions OData by deviceIdentity
     */
    async transactionsByDeviceODataRaw(
        requestParameters: TransactionsByDeviceODataRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<Transaction>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling transactionsByDeviceOData().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/transactions-odata`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(TransactionFromJSON),
        );
    }

    /**
     * Device Transactions OData by deviceIdentity
     */
    async transactionsByDeviceOData(
        requestParameters: TransactionsByDeviceODataRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<Transaction>> {
        const response = await this.transactionsByDeviceODataRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * All Charger Transactions OData (IlluminateAdmin or JETChargeStaff users only)
     * @deprecated
     */
    async transactionsODataRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<Transaction>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/transactions/transactions-odata`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(TransactionFromJSON),
        );
    }

    /**
     * All Charger Transactions OData (IlluminateAdmin or JETChargeStaff users only)
     * @deprecated
     */
    async transactionsOData(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<Transaction>> {
        const response = await this.transactionsODataRaw(initOverrides);
        return await response.value();
    }
}
